import { useState } from 'react';
import MD5 from 'crypto-js/md5';

import request, { setToken } from '@/request';

// 登录表单负责账号密码输入、提交登录请求和触发忘记密码入口。
export default function SignIn({ onSuccess, onForgotPassword }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const isFormValid = phone && password;

  // 处理回车提交，避免表单未填写完整时触发登录。
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (isFormValid && !isLoading) {
        handleSubmit(e);
      }
    }
  };

  // 提交登录请求，保留原有手机号、密码加密和用户信息获取逻辑。
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setIsLoading(true);

    try {
      const loginInfo = await request.post('/auth/login', {
        phone: String(phone).trim(),
        password: MD5(String(password).trim()).toString(),
      });

      setToken(loginInfo.accessToken);
      const userInfo = await request.get('/system/user');
      onSuccess?.(userInfo);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      onKeyDown={handleKeyDown}
      className="w-full"
    >
      <div className="w-full">
        <label
          htmlFor="phone"
          className={`flex h-[45px] items-start border-b text-left transition-colors ${
            focusedField === 'phone' ? 'border-[#007eff]' : 'border-[#ebebeb]'
          }`}
        >
          <span className="w-[60px] shrink-0 text-[14px] leading-[18px] text-[#333]">
            账号
          </span>
          <input
            id="phone"
            type="tel"
            placeholder="输入账号"
            value={phone}
            maxLength={11}
            onChange={(e) => setPhone(e.target.value)}
            onFocus={() => setFocusedField('phone')}
            onBlur={() => setFocusedField(null)}
            className="h-[18px] flex-1 bg-transparent text-[14px] leading-[18px] text-[#333] placeholder:text-[#999] focus:outline-none"
            required
          />
        </label>

        <label
          htmlFor="password"
          className={`mt-[31px] flex h-[45px] items-start border-b text-left transition-colors ${
            focusedField === 'password'
              ? 'border-[#007eff]'
              : 'border-[#ebebeb]'
          }`}
        >
          <span className="w-[60px] shrink-0 text-[14px] leading-[18px] text-[#333]">
            密码
          </span>
          <input
            id="password"
            type="password"
            placeholder="输入密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setFocusedField('password')}
            onBlur={() => setFocusedField(null)}
            className="h-[18px] flex-1 bg-transparent text-[14px] leading-[18px] text-[#333] placeholder:text-[#999] focus:outline-none"
            required
          />
        </label>
      </div>

      <div className="mt-[23px] flex items-center justify-end text-[14px] leading-[14px]">
        {/* <span className="text-[#007eff]">忘记帐号</span>
        <span className="mx-[10px] h-[14px] w-[2px] bg-[#efefef]" /> */}
        <button
          type="button"
          onClick={onForgotPassword}
          className="cursor-pointer text-[#007eff] transition-opacity hover:opacity-80"
        >
          忘记密码
        </button>
      </div>

      <button
        type="submit"
        disabled={isLoading || !isFormValid}
        className={`mt-[22px] flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] text-[14px] leading-[18px] text-white transition-opacity ${
          isFormValid && !isLoading
            ? 'bg-[#0a0a0a] hover:opacity-90'
            : 'bg-[#0a0a0a] opacity-60'
        }`}
      >
        {isLoading && (
          <svg
            className="h-4 w-4 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        )}
        <span>{isLoading ? '登录中...' : '登录'}</span>
      </button>
    </form>
  );
}
